// extracted by css-extract-rspack-plugin
export default {"NavBack":"NavBack-module__NavBack__dVDUp","Container":"NavBack-module__Container__yNdA3","Link":"NavBack-module__Link__KSjei"};